module.exports = __webpack_public_path__ + "static/media/HyblockCapital.69f82d03.webm";